import { Alert, useTheme } from "@mui/material";
import { type CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import { forwardRef } from "react";

const NotificationItem = forwardRef<HTMLDivElement, CustomContentProps>(({ id, message, variant }, ref) => {
	const { closeSnackbar } = useSnackbar();
	const theme = useTheme();

	return (
		<SnackbarContent ref={ref}>
			<Alert
				severity={variant === "warning" ? "warning" : "info"}
				onClose={() => closeSnackbar(id)}
				sx={{
					display: "flex",
					alignItems: "center",
					width: "100%",
					boxShadow: theme.shadows[4],
					".MuiAlert-action": {
						padding: "0 0 0 8px",
					},
				}}
			>
				{message}
			</Alert>
		</SnackbarContent>
	);
});

export { NotificationItem };
